// react
import styled from 'styled-components';

// store
import { useSelector } from 'store';

// components
import { Container } from '@karehero/llama/components/atoms/Container/Container';
import { TOS } from '@karehero/llama/components/molecules/TOS/TOS';

/**
 * TermsOfService shows the terms of service page.
 */
export const TermsOfService = () => {
  return (
    <StyledContainer size='lg'>
      <TOS isHideConsent />
    </StyledContainer>
  );
};

const StyledContainer = styled(Container)`
  padding-top: ${(props) => props.theme.spacing[48]};
  padding-bottom: ${(props) => props.theme.spacing[48]};
`;

export default TermsOfService;
